import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs';
import { CamelCasePipe } from 'src/app/pipes/camelcase.filter/camelcase.filter.pipe';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert } from 'src/app/utils/swal';
import { onTimeChange } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-add-space-types',
  templateUrl: './add-space-types.component.html',
  styleUrls: ['./add-space-types.component.css']
})
export class AddSpaceTypesComponent implements OnInit, OnDestroy {
  spaceTypeForm !: FormGroup;
  spaceTypeId: any
  submitted = false;
  levelOfServices:any;
  wnrValue: boolean = false;

  // Edit Modal Inputs and Outputs
  @Input() spaceType: any;
  @Input() source: any;
  @Output() onSaveSpaceType = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<any>();
  // Edit Modal Inputs and Outputs End

  constructor(
    private SpaceTypeService: SpaceTypeService,
    private activatedRoute: ActivatedRoute,
    private levelOfService:LosService,
    private router: Router,
    private fb: FormBuilder) { }

  ngOnInit() {
    
    this.getLevelOfService();

    this.spaceTypeForm = this.fb.group({
      los: ["", Validators.required],
      title: ["", Validators.required],
      preLoadTime: [""],
      preUnLoadTime: [""],
      loadTime: ["", Validators.required],
      unloadTime: ["", Validators.required],
      isActive: [true, Validators.required],
      description: ["",Validators.required],
      wnr: [false],
      isWeightOptional: [false]
      // profileImageURL:['']
    });

    if (this.source === 'modal' && this.spaceType) {
      this.spaceTypeId = this.spaceType.id;
      this.getById();
    } else {
      this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
        if (param && param['id']) {
          this.spaceTypeId = param['id'];
          this.getById();
        }
      });
    }

  }

  save() {
    this.submitted = true;
    if (this.spaceTypeForm.invalid) {
      return;
    }
    let payload = this.spaceTypeForm.value;
    delete payload.preLoadTime
    delete payload.preUnLoadTime
    this.SpaceTypeService.save(this.spaceTypeId, payload).pipe(untilDestroyed(this)).subscribe(
      (data) => {
        if (data) {
          if (this.source === 'modal') {
            this.onSaveSpaceType.emit(data);
          } else {
            this.router.navigateByUrl("configurations/spacetypes");
          }
          
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );

  }

  getById() {
    this.SpaceTypeService.getById(this.spaceTypeId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        const todayDate = moment().format("YYYY-MM-DD");
        this.spaceTypeForm.patchValue({
          ...data,
          preLoadTime: data.loadTime ? moment(data.loadTime, "HH:mm").toDate() : null,
          preUnLoadTime: data.unloadTime ? moment(data.unloadTime, "HH:mm").toDate() :null

        })
      }

    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    })
  }

  getLevelOfService() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.levelOfServices = data.results.map((item: any) => {
            return {
              ...item,
              title: new CamelCasePipe().transform(item.title)
            };
          });
        }
      })
  }

  get form() {
    return this.spaceTypeForm.controls;
  }

  onLoadTimeChange(evt: any) {
    this.spaceTypeForm.patchValue({
      loadTime: moment(evt).format('HH:mm'),
    });
  }

  onUnLoadTimeChange(evt: any) {
    this.spaceTypeForm.patchValue({
      unloadTime: moment(evt).format("HH:mm"),
    });
  }

  toggleWNR(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.spaceTypeForm.patchValue({
      wnr: isChecked,
    });
  }

  toggleWeight(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.spaceTypeForm.patchValue({
      isWeightOptional: isChecked,
    });
  }
  ngOnDestroy() {

  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
  
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

}
